import { LayoutService } from '@/app/layout/service/layout.service';
import { Component, computed, inject } from '@angular/core';

@Component({
    selector: '[app-footer]',
    standalone: true,
    template: `
        <div class="layout-footer">
            <span class="footer-copyright">&#169; Vitrine Retail - 2026</span>
        </div>
    `
})
export class AppFooter {
    layoutService = inject(LayoutService);

    isDarkTheme = computed(() => this.layoutService.isDarkTheme());
}
